/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type Person from 'linced-app/models/person';
import type School from 'linced-app/models/school';

// Proto: attendance.Intervention.
export default class Intervention extends Model {
  declare [Type]: 'attendance/intervention';

  // createTime is when the resource was created in seconds from the epoch.
  @attr('number')
  declare createTime: number | undefined;

  // updateTime is when the resource was updated in seconds from the epoch.
  @attr('number')
  declare updateTime: number | undefined;

  // schoolId is the unique identifier of the school the attendance intervention
  // audit log relates to
  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @alias('schoolId')
  declare school: AsyncBelongsTo<School>;

  // personId provides the unique identifier of the Person whose intervention
  // record was changed
  @belongsTo('person', { async: true, inverse: null })
  declare personId: AsyncBelongsTo<Person>;

  @alias('personId')
  declare person: AsyncBelongsTo<Person>;

  // intervenerId provides the unique identifier of the Person who changed the
  // intervention record
  @belongsTo('person', { async: true, inverse: null })
  declare intervenerId: AsyncBelongsTo<Person>;

  @alias('intervenerId')
  declare intervener: AsyncBelongsTo<Person>;

  // academicYear is the year the intervention is for
  @attr('string', { defaultValue: '' })
  declare academicYear: string;

  // term is the term the intervention is for
  @attr('number', { defaultValue: 0 })
  declare termNumber: number;

  // date contains the date the intervention was created as a string
  // to facilitate filtering.
  @attr('string')
  declare date: string | undefined;

  // due date of the intervention
  @attr('string')
  declare dueDate: string | undefined;

  // completedDate is when the intervention action was taken
  @attr('string')
  declare completedDate: string | undefined;

  // status is an enum for a status
  @attr('number', { defaultValue: 0 })
  declare status: number;

  // note contains any note regarding the intervention taken
  @attr('string', { defaultValue: '' })
  declare note: string;
}
